import { Flex } from 'components/base/layout-components';
import { useEffect, useState } from 'react';
import { TransitionConfig } from './TransitionConfig';
import Text from 'components/base/Text';
import DashedArrow from 'images/dashed-arrow.svg';
import { MTTR_STRATEGY } from '@linearb/linjs-common';

const INITIAL_TRANSITION = {
  from: null,
  to: null
};

export const TRANSITION_POSITION = {
  START: { key: 'start', title: 'Start' },
  END: { key: 'end', title: 'End' }
};

export const MTTRDuration = ({
  statuses,
  customFields,
  incidentStrategy,
  setIncidentStrategy,
  incidentConfig,
  setIncidentConfig
}) => {
  const [stateTransition, setStateTransition] = useState(INITIAL_TRANSITION);
  const [customFieldTransition, setCustomFieldTransition] =
    useState(INITIAL_TRANSITION);

  const onChangeStrategy = value => {
    setIncidentStrategy(value);
    if (value === MTTR_STRATEGY.STATE_TRANSITION) {
      setIncidentConfig(stateTransition);
    } else {
      setIncidentConfig(customFieldTransition);
    }
  };

  useEffect(() => {
    if (incidentStrategy === MTTR_STRATEGY.STATE_TRANSITION) {
      setStateTransition(incidentConfig);
    } else {
      setCustomFieldTransition(incidentConfig);
    }
  }, []);

  useEffect(() => {
    if (incidentStrategy === MTTR_STRATEGY.STATE_TRANSITION) {
      setIncidentConfig(stateTransition);
    } else {
      setIncidentConfig(customFieldTransition);
    }
  }, [incidentStrategy, stateTransition, customFieldTransition]);

  return (
    <Flex direction='column' pt='medium'>
      <Text weight='bold' size='medium'>
        MTTR DURATION
      </Text>
      <Flex direction='row' pt='small'>
        <TransitionConfig
          statuses={statuses}
          customFields={customFields}
          selectedStrategy={incidentStrategy}
          onChangeStrategy={onChangeStrategy}
          stateTransition={stateTransition.from}
          setStateTransition={value =>
            setStateTransition({ ...stateTransition, from: value })
          }
          customFieldTransition={customFieldTransition.from}
          setCustomFieldTransition={value =>
            setCustomFieldTransition({
              ...customFieldTransition,
              from: value
            })
          }
          position={TRANSITION_POSITION.START}
          dataCyPrefix='mttr-duration-start'
        />
        <Flex pr='x-x-large' pl='x-x-large' items='center'>
          <img src={DashedArrow} />
        </Flex>
        <TransitionConfig
          statuses={statuses}
          customFields={customFields}
          selectedStrategy={incidentStrategy}
          onChangeStrategy={onChangeStrategy}
          stateTransition={stateTransition.to}
          setStateTransition={value =>
            setStateTransition({ ...stateTransition, to: value })
          }
          customFieldTransition={customFieldTransition.to}
          setCustomFieldTransition={value =>
            setCustomFieldTransition({ ...customFieldTransition, to: value })
          }
          position={TRANSITION_POSITION.END}
          dataCyPrefix='mttr-duration-end'
        />
      </Flex>
    </Flex>
  );
};
